import React from 'react';
import { XCircle } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function FailedMethods() {
  const methods = ['Seguir rutinas súper rígidas que no se adaptan a los cambios de tu bebé ni a su ritmo real.', 'Dejarlo llorar hasta que "aprenda" — y sentir que algo se te rompe por dentro cada vez.', 'Buscar consejos en internet que se contradicen entre sí y te dejan más confundida que antes.', 'Esperar a que esté agotado para dormirlo, y que termine más activo y luchando contra el sueño.', 'Probar soluciones genéricas que no respetan el ritmo ni la etapa de tu bebé.'];
  return <section className="bg-lavender py-24 px-6 md:px-12" data-id="element-3">
      <div className="max-w-4xl mx-auto" data-id="element-4">
        <FadeIn data-id="element-5">
          <h2 className="text-4xl md:text-5xl text-center mb-16" data-id="element-6">
            Lo que ya probaste <br data-id="element-7" />
            <span className="italic text-periwinkle" data-id="element-8">
              (y por qué no funcionó)
            </span>
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-9">
          {methods.map((method, index) => <FadeIn key={index} delay={0.1 * index} direction="left" data-id="element-10">
              <div className="flex items-start space-x-4 bg-white/60 p-6 rounded-2xl" data-id="element-11">
                <XCircle className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-12" />
                <p className="text-lg text-brown/90" data-id="element-13">{method}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}